import { createClient } from '@supabase/supabase-js';
import { Database } from '@/types/supabase';

// For Cloudflare Pages, use these environment variables
const supabaseUrl = "https://ddwqnzejmhvxqszbdynu.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRkd3FuemVqbWh2eHFzemJkeW51Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMyMDE0MjQsImV4cCI6MjA1ODc3NzQyNH0.1puH83mY8V8i2iI1-CxpNd0Nu6PRjZjDL-PqoQY5s_4";

// Validate environment variables are present
if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    'Missing Supabase environment variables. Check your .env file and Cloudflare Pages environment configuration.'
  );
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});